export enum ScreenState {
  TITLESCREEN = 0,
  MAIN_MENU = 1,
  BATTLE_SETUP = 2,
  BATTLE = 3,
  RECRUIT = 4,
  SCHOOL = 5,
  MAGE = 6,
  SHOP = 7,
  OTHER_TEAMS = 8,
  CHANGE_PLAYER = 9,
  SETTINGS = 10,
  BATTLE_SUMMARY = 11,
  KILL_LEADERBOARD = 12,
}

export interface ClickableRegion {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  onClick: () => void;
}

export interface MapData {
  image: HTMLImageElement;
  clip: HTMLImageElement;
}

export interface AssetManifest {
  gladiators: HTMLCanvasElement[];
  maps: MapData[];
  battleArrows: HTMLCanvasElement[];
  hitMarkers: HTMLCanvasElement[];
  titleScreen: HTMLImageElement;
  battleSetupArrow: HTMLCanvasElement;
  shootIcon: HTMLCanvasElement;
}

export interface MouseState {
  x: number;
  y: number;
  isDown: boolean;
}

export interface KeyState {
  [key: string]: boolean;
}

export const CONSTANTS = {
  // Dimensions - larger for modern screens
  CANVAS_WIDTH: 1024,
  CANVAS_HEIGHT: 700,
  MAP_WIDTH: 7,
  MAP_HEIGHT: 10,
  MAP_TILE_SIZE: 34,

  // Colors
  MAIN_BACKGROUND: '#c0c0c0',
  GAME_NAME_OUTLINE: '#711010',
  MAGENTA_TRANSPARENCY: '#ff00ff',
  TOP1_BACKGROUND: '#ff8080',
  TOP2_BACKGROUND: '#ffc0c0',
  BUTTON_AREA_BACKGROUND: '#0000c0',
  BOTTOM_TXT_BACKGROUND: '#8080ff',
  GLADIATOR_TITLE: '#000080',
  SPECIAL_GLADIATOR_TITLE: '#800000',
  SELECTED_GLADIATOR: '#646464',
  TABLE_BORDER: '#646464',
  BATTLE_SETUP_BACKGROUND: '#000080',
  BATTLE_BACKGROUND: '#800080',
  CLIPPED_TILE: '#ed1c24',
  RECRUIT_BACKGROUND: '#e0e0e0',
  SCHOOL_BACKGROUND: '#008080',
  CHANGE_PLAYER_BACKGROUND: '#0000ff',
  RACE_OF_MONTH: '#ff0000',

  // Fonts
  GAME_NAME_FONT: 'bold 55px "comic sans ms"',
  GAME_VERSION_FONT: '21px "comic sans ms"',
  TITLESCREEN_BUTTON_FONT: 'bold 16px "comic sans ms"',
  MAIN_FONT: 'bold 12px "comic sans ms"',
  BIG_FONT: 'bold 19px "comic sans ms"',
  BOTTOM_TXT_FONT: 'bold 13px "comic sans ms"',
  MSG_FONT: '11px "comic sans ms"',
  GLADIATOR_NAME_FONT: 'bold 16px "comic sans ms"',
  GLADIATOR_STAT_TITLE_FONT: 'bold 12px "comic sans ms"',
  MAIN_BUTTON_FONT: 'bold 13px "comic sans ms"',

  // Game text
  GAME_NAME: 'Avoin Areena',
  GAME_VERSION: 'v0.2',
  NEW_GAME_TXT: 'Uusi peli',
  LOAD_GAME_TXT: 'Avaa peli',
  EXIT_GAME_TXT: 'Lopeta',

  // Asset counts
  GLADIATOR_COUNT: 36,
  BATTLE_ARROW_COUNT: 8,
  HIT_MARKER_COUNT: 5,
  MAP_COUNT: 1,
} as const;
